import { render, staticRenderFns } from "./Appointments.vue?vue&type=template&id=c93dc966&"
import script from "./Appointments.vue?vue&type=script&lang=js&"
export * from "./Appointments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports